import React from "react";
// import Side from "./Side";
// import Cover from './Cover'
import Simple from "./Simple";
import View from "views";
import { useSelector } from "react-redux";
import { LAYOUT_TYPE_BLANK } from "constants/theme.constant";
import BG from "./endless-constellation.png";

const AuthLayout = (props) => {
  const layoutType = useSelector((state) => state.theme.layout.type);

  return (
    <>
      <div
        style={{
          background: "url(" + BG + ")",
          backgroundRepeat: "repeat",
          backgroundSize: "25% 50%",
          // ba,
        }}
        className="absolute left-0 h-full right-0 top-0 bottom-0 w-full"
      ></div>
      <div className="app-layout-blank flex flex-auto flex-col min-h-[100vh]">
        {layoutType === LAYOUT_TYPE_BLANK ? (
          <View {...props} />
        ) : (
          <Simple>
            <View {...props} />
          </Simple>
        )}
      </div>
    </>
  );
};

export default AuthLayout;
